// extracted by mini-css-extract-plugin
export default {"appInput":"AppInput_appInput__3afdf","error":"AppInput_error__fJ2lH"};